import React, { Component, Fragment } from "react";
import Grid from "../../Utils/Grid";
import { reduxForm, Field } from "redux-form";
import { standardActions } from "../../Utils/Grid/StandardActions";
import { ROLE_ADMIN, ROLE_CABIN_ATTENDANT, VEHICLE_STATUS } from "../../../../utility/constants";
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import CustomDropdown from "../../Utils/renderField/customDropdown";
import CustomSelectFIeld from "../../Utils/FieldFilters/SelectField";
import "./vehicles-list.css";


class List extends Component {
    componentDidMount() {
        this.props.listarPersonalizado();
        this.props.stationFilterList(true);
        this.props.vehicleTypesFilterList(true);
        this.props.changeValueSelectVehicles();
    }
    state = {
        indexRow: null,
    }

    handleDownload = () => {
        const {
            custom_search,
            filter_station,
            filter_vehicle_type,
            filter_disponibility
        } = this.props;

        let url = '/api/vehicle/download_list/?';

        // Add existing filters to URL
        if (custom_search) url += `search=${custom_search}&`;
        if (filter_station) url += `station=${filter_station}&`;
        if (filter_vehicle_type) url += `vehicle_type=${filter_vehicle_type}&`;
        if (filter_disponibility) url += `disponibility=${filter_disponibility}&`;

        const token = localStorage.getItem("token");
        if (token) url += `auth_token=${token}`;

        // Trigger download
        window.open(url, '_blank');
    }

    render() {
        const {
            listarPersonalizado,
            data,
            loader,
            onSortChange,
            searchCustomChange,
            eliminar,
            me
        } = this.props;

        const STATUS = [{ "label": "Todos", "value": null }].concat(VEHICLE_STATUS);

        const columns = [
            {
                dataField: "plate",
                text: "Placa",
                sort: true,
                attrs: { "data-label": "Placa" },
                formatter: (cell) => <span className="font-weight-bold text-dark">{cell}</span>
            },
            {
                dataField: "station.name",
                text: "Estación",
                attrs: { "data-label": "Estación" },
                formatter: (cell) => <span className="text-dark">{cell}</span>
            },
            {
                dataField: "note",
                text: "Nota",
                sort: true,
                attrs: { "data-label": "Nota" },
                formatter: (cell) => <span className="text-muted">{cell ? cell : '---'}</span>
            },
            {
                dataField: "station.address",
                text: "Dirección",
                attrs: { "data-label": "Dirección" },
                formatter: (cell) => <span className="text-muted small">{cell}</span>
            },
            {
                dataField: "disponibility",
                text: "Estado",
                sort: true,
                attrs: { "data-label": "Estado" },
                formatter: (cell, row) => {
                    let color = "status-point-green";
                    let textColor = "text-success"; // for dropdown generic text class

                    if (row.disponibility == 10) {
                        color = "status-point-green";
                        textColor = "text-success";
                    } else if (row.disponibility == 40) {
                        color = "status-point-orange"; // No disponible
                        textColor = "text-warning";
                    } else if (row.disponibility == 50) {
                        color = "status-point-red"; // ?
                        textColor = "text-danger";
                    } else if (row.disponibility == 60) {
                        color = "status-point-yellow";
                        textColor = "text-warning";
                    }

                    let dropdownColor = "";
                    if (row.disponibility == 10) dropdownColor = "text-success";
                    else if (row.disponibility == 40) dropdownColor = "text-warning";
                    else if (row.disponibility == 50) dropdownColor = "text-danger";
                    else if (row.disponibility == 60) dropdownColor = "text-warning";

                    return (
                        <div className="d-flex align-items-center justify-content-end w-100">
                            {this.props.me.role === ROLE_CABIN_ATTENDANT || this.props.me.role === ROLE_ADMIN ?
                                <CustomDropdown
                                    rowId={row.id}
                                    color={dropdownColor}
                                    title={row.disponibility_label}
                                    disabled={row.disponibility === 40}
                                    options={
                                        [
                                            { value: '10', label: "Disponible", action: this.props.changeStatusVehicle, color: 'text-success' },
                                            { value: '50', label: "No disponible", action: this.props.changeStatusVehicle, color: 'text-danger' },
                                            { value: '60', label: "En reparacion", action: this.props.changeStatusVehicle, color: 'text-warning' },
                                        ]
                                    }
                                /> :
                                <div className="d-flex align-items-center">
                                    <span className={`status-point ${color}`}></span>
                                    <span className="status-text ml-2">{row.disponibility_label}</span>
                                </div>
                            }
                        </div>
                    );
                },
            },
            {
                dataField: "id",
                text: "Acciones",
                attrs: { "data-label": "Acciones" },
                formatter: (cell, row) => {
                    const canEditPerm = canEdit(this.props.me, MODULES.VEHICLES);
                    const canDeletePerm = canDelete(this.props.me, MODULES.VEHICLES);

                    return (
                        <div className="d-flex justify-content-center gap-2">
                            <button
                                className="btn-action btn-view"
                                onClick={() => window.location.href = `#/vehicles/${row.id}`}
                                title="Ver"
                            >
                                <span className="material-icons">visibility</span>
                            </button>
                            {canEditPerm && (
                                <button
                                    className="btn-action btn-edit"
                                    onClick={() => window.location.href = `#/vehicles/${row.id}/editar`}
                                    title="Editar"
                                >
                                    <span className="material-icons">edit</span>
                                </button>
                            )}
                            {canDeletePerm && (
                                <button
                                    className="btn-action btn-delete"
                                    onClick={() => eliminar(row.id)}
                                    title="Eliminar"
                                >
                                    <span className="material-icons">delete</span>
                                </button>
                            )}
                        </div>
                    )
                }
            },
        ];

        return (
            <div className="vehicles-page-container">
                {/* Header */}
                <div className="vehicles-page-header">
                    <div className="header-left">
                        <div className="title-section">
                            <h1>Vehículos</h1>
                            <p className="subtitle">Listado General De Vehículos</p>
                        </div>
                    </div>
                    {/* Create Button only for Admin */}
                    {canCreate(this.props.me, MODULES.VEHICLES) && (
                        <button
                            className="vehicles-create-btn"
                            onClick={() => window.location.href = "#/vehicles/create"}
                        >
                            <span className="material-icons">add_circle_outline</span>
                            Crear Vehículo
                        </button>
                    )}
                </div>

                {/* Filters Row */}
                <div className="vehicles-filters-card">
                    <div className="d-flex align-items-center justify-content-between gap-4 flex-wrap mobile-filters-col">
                        {/* Filters Group */}
                        <div className="d-flex align-items-center gap-4 flex-grow-1 mobile-filters-list">
                            <div className="vehicles-filter-wrapper" style={{ maxWidth: '220px' }}>
                                <span className="material-icons filter-icon left">filter_alt</span>
                                <CustomSelectFIeld
                                    name="station"
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="Estación"
                                    value={this.props.filter_station}
                                    setValue={this.props.filterStation}
                                    options={this.props.station.filter_list}
                                    disabled={false}
                                />
                            </div>

                            <div className="vehicles-filter-wrapper" style={{ maxWidth: '220px' }}>
                                <span className="material-icons filter-icon left">filter_alt</span>
                                <CustomSelectFIeld
                                    name="vehicle_type"
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="Tipo de vehículo"
                                    value={this.props.filter_vehicle_type}
                                    setValue={this.props.filterVehicleType}
                                    options={this.props.vehicles_type.filter_list}
                                />
                            </div>

                            <div className="vehicles-filter-wrapper" style={{ maxWidth: '220px' }}>
                                <span className="material-icons filter-icon left">filter_alt</span>
                                <CustomSelectFIeld
                                    name="disponibility"
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="Disponibilidad"
                                    value={this.props.filter_disponibility}
                                    setValue={this.props.filterDisponibility}
                                    options={STATUS}
                                />
                            </div>

                            <div className="vehicles-filter-wrapper flex-grow-1 search-wrapper">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar"
                                    onChange={(e) => searchCustomChange(e.target.value)}
                                />
                                <div className="search-separator"></div>
                                <span className="material-icons filter-icon right">search</span>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        {!!(this.props.me && this.props.me.role === ROLE_ADMIN) && (
                            <button
                                className="vehicles-create-btn"
                                onClick={() => window.location.href = "#/vehicles/create"}
                            >
                                <span className="material-icons">add_circle_outline</span>
                                Crear Vehículo
                            </button>
                        )}

                        {/* Export Button */}
                        <button
                            className="vehicles-export-btn"
                            onClick={this.handleDownload}
                        >
                            <span className="material-icons">file_download</span>
                            Exportar Listado
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div className="vehicles-table-card">
                    <Grid
                        data={data}
                        loading={loader}
                        columns={columns}
                        onPageChange={listarPersonalizado}
                        onSortChange={onSortChange}
                        noDataMessage={"Sin vehículos"}
                    />
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: "ListVehicles", // a unique identifier for this form
})(List);
